module.exports = __webpack_public_path__ + "img/footer-icon-003.b1299d9.webp";